module["exports"] = [
  "#####",
  "####",
  "###"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/pt_BR/address/building_number.js
// module id = 1567
// module chunks = 0